<template>
  <div class="detail-container">
    <detail-header />
    <detail-base-info />
    <detail-things-like />
    <question-list />
    <photo-list />
  </div>
</template>

<script>
// 页面标题
import DetailHeader from './component/detail-header'
// 基本信息
import DetailBaseInfo from './component/detail-base-info'
// 兴趣
import DetailThingsLike from './component/detail-things-like'
// 问题列表
import QuestionList from './component/detail-question-list'
// 相册列表
import PhotoList from './component/detail-photo-list'
export default {
  name: 'UserDetail',
  components: {
    DetailHeader,
    DetailBaseInfo,
    DetailThingsLike,
    QuestionList,
    PhotoList
  },
  created(){
    // const mobile = this.$route.query.mobile;
    const {userId} = this.$route.query
    this.$store.dispatch('user/getUserInfo', { userId }).then((res) => {
    })
  }
}
</script>

<style lang="scss" scoped>
.detail-container {
  padding: 10px;
  margin-top: 20px;
}
</style>
